export const GET_MERCHANT_LINK_PAYMENT = "GET_MERCHANT_LINK_PAYMENT"
export const GET_MERCHANT_LINK_PAYMENT_SUCCESS = "GET_MERCHANT_LINK_PAYMENT_SUCCESS"
export const GET_MERCHANT_LINK_PAYMENT_FAIL = "GET_MERCHANT_LINK_PAYMENT_FAIL"

export const GET_MERCHANT_LINK_PAYMENT_BY_GUID = "GET_MERCHANT_LINK_PAYMENT_BY_GUID"
export const GET_MERCHANT_LINK_PAYMENT_BY_GUID_SUCCESS = "GET_MERCHANT_LINK_PAYMENT_BY_GUID_SUCCESS"
export const GET_MERCHANT_LINK_PAYMENT_BY_GUID_FAIL = "GET_MERCHANT_LINK_PAYMENT_BY_GUID_FAIL"

export const GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY = "GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY"
export const GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_SUCCESS = "GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_SUCCESS"
export const GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_FAIL = "GET_MERCHANT_LINK_PAYMENT_SPESIFIC_BY_KEY_FAIL"

export const ADD_MERCHANT_LINK_PAYMENT = "ADD_MERCHANT_LINK_PAYMENT"
export const ADD_MERCHANT_LINK_PAYMENT_SUCCESS = "ADD_MERCHANT_LINK_PAYMENT_SUCCESS"
export const ADD_MERCHANT_LINK_PAYMENT_FAIL = "ADD_MERCHANT_LINK_PAYMENT_FAIL"

export const UPDATE_MERCHANT_LINK_PAYMENT = "UPDATE_MERCHANT_LINK_PAYMENT"
export const UPDATE_MERCHANT_LINK_PAYMENT_SUCCESS = "UPDATE_MERCHANT_LINK_PAYMENT_SUCCESS"
export const UPDATE_MERCHANT_LINK_PAYMENT_FAIL = "UPDATE_MERCHANT_LINK_PAYMENT_FAIL"

export const UPDATE_MERCHANT_LINK_PAYMENT_STATUS = "UPDATE_MERCHANT_LINK_PAYMENT_STATUS"
export const UPDATE_MERCHANT_LINK_PAYMENT_STATUS_SUCCESS = "UPDATE_MERCHANT_LINK_PAYMENT_STATUS_SUCCESS"
export const UPDATE_MERCHANT_LINK_PAYMENT_STATUS_FAIL = "UPDATE_MERCHANT_LINK_PAYMENT_STATUS_FAIL"

export const DELETE_MERCHANT_LINK_PAYMENT = "DELETE_MERCHANT_LINK_PAYMENT"
export const DELETE_MERCHANT_LINK_PAYMENT_SUCCESS = "DELETE_MERCHANT_LINK_PAYMENT_SUCCESS"
export const DELETE_MERCHANT_LINK_PAYMENT_FAIL = "DELETE_MERCHANT_LINK_PAYMENT_FAIL"

export const SHARE_MERCHANT_LINK_PAYMENT = "SHARE_MERCHANT_LINK_PAYMENT"
export const SHARE_MERCHANT_LINK_PAYMENT_SUCCESS = "SHARE_MERCHANT_LINK_PAYMENT_SUCCESS"
export const SHARE_MERCHANT_LINK_PAYMENT_FAIL = "SHARE_MERCHANT_LINK_PAYMENT_FAIL"

export const MERCHANT_LINK_DO_PAYMENT = "MERCHANT_LINK_DO_PAYMENT"
export const MERCHANT_LINK_DO_PAYMENT_SUCCESS = "MERCHANT_LINK_DO_PAYMENT_SUCCESS"
export const MERCHANT_LINK_DO_PAYMENT_FAIL = "MERCHANT_LINK_DO_PAYMENT_FAIL"

export const MERCHANT_LINK_CHECK_BIN_CARD_NUMBER = "MERCHANT_LINK_CHECK_BIN_CARD_NUMBER"
export const MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_SUCCESS = "MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_SUCCESS"
export const MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_FAIL = "MERCHANT_LINK_CHECK_BIN_CARD_NUMBER_FAIL"
export const MERCHANT_LINK_CLEAR_CHECK_BIN_ERROR = "MERCHANT_LINK_CLEAR_CHECK_BIN_ERROR"

export const MERCHANT_LINK_PAYMENT_API_ERROR = "MERCHANT_LINK_PAYMENT_API_ERROR"